import React, { useEffect, useRef, useState } from "react";
import { connect } from "react-redux";
// import { setCurrentUser } from "../store/actions/authActions.js";
import { NavLink } from "react-router-dom";
import { usePostHog } from '@posthog/react';
import TableSearchBar from "../../components/TableSearchBar";
import { initFlowbite } from "flowbite";
import { Button, Modal } from "flowbite-react";
import { HiOutlineExclamationCircle } from "react-icons/hi";
import instance, { fetchEntryDueDate } from "../../api/api";
import { Loader } from "../../components/Loader";
import PerspectiveBadge from "../../components/PerspectiveBadge";
import { FormateDate } from "../../utils/FormatDate";
// import { FormatDueDates } from "../../utils/FormatDueDates";
import { useTenant } from "../../context/Tenant/TenantContext";
// const config = localStorage.getItem("parameters");

import {
  createColumnHelper,
  flexRender,
  getCoreRowModel,
  useReactTable,
} from "@tanstack/react-table";
import { sources } from "../../constants/sources";

type Risk = {
  id?: string;
  riskNumber?: string;
  riskName: string;
  description: string;
  source: string;
  rootCause: string;
  objective: string;
  perspective: string;
  createdAt?: string;
};
function RiskRegistry() {
  const posthog = usePostHog();
  const { config, loading: tenantLoading } = useTenant();
  const [newRisk, setNewRisk] = useState<Risk>({
    riskName: "",
    description: "",
    source: "",
    rootCause: "",
    objective: "",
    perspective: "",
  });
  const [updatedRisk, setUpdatedRisk] = useState<Risk>({
    riskName: "",
    description: "",
    source: "",
    rootCause: "",
    objective: "",
    perspective: "",
  });
  const [currentRiskDetails, setCurrentRiskDetails] = useState<any>({});
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isDeleting, setIsDeleting] = useState(false);
  const [isLoadingRisks, setIsLoadingRisks] = useState(false);
  const [allRisks, setAllRisks] = useState([]);
  const closeAddNewRiskDrawerButtonRef = useRef<any>(null);
  const closeEditRiskDrawerButtonRef = useRef<any>(null);

  const [selectedRiskId, setSelectedRiskId] = useState<any>("");
  const [isEditDrawerOpen, setIsEditDrawerOpen] = useState(false);
  // const [dueDate, setDueDate] = useState<any>(null);
  const [isEntryLocked, setIsEntryLocked] = useState(false);
  const today = new Date();
  const [pageError, setPageError] = useState<any>(null);

  const editDrawerRef = useRef<any>(null);

  const department = localStorage.getItem("department");

  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(25);
  const [searchTerm, setSearchTerm] = useState("");
  const [highlightedRiskId, setHighlightedRiskId] = useState<any>(null);
  const [filteredObjectives, setFilteredObjectives] = useState<string[]>([]);
  
  // State for handling "Other" source option in edit drawer
  const [isOtherSourceSelected, setIsOtherSourceSelected] = useState(false);
  const [customSource, setCustomSource] = useState("");
  
  // State for handling "Other" source option in add new risk drawer
  const [isOtherSourceSelectedNew, setIsOtherSourceSelectedNew] = useState(false);
  const [customSourceNew, setCustomSourceNew] = useState("");

  const createNewRisk = async (e: any) => {
    e.preventDefault();
    setIsSubmitting(true);

    if (newRisk.perspective === "Select Perspective") {
      setPageError("Perspective must be selected");
      setIsSubmitting(false);
      return;
    }

    if (newRisk.source === "Select Source") {
      setPageError("Source must be selected");
      setIsSubmitting(false);
      return;
    }

    try {
      await instance.post("/api/employee/riskRegister/create", newRisk);
      posthog.capture('employee_risk_created', { perspective: newRisk.perspective, source: newRisk.source });
      // Close the drawer
      if (closeAddNewRiskDrawerButtonRef.current) {
        closeAddNewRiskDrawerButtonRef.current.click();
      }
      // Reset custom source states
      setIsOtherSourceSelectedNew(false);
      setCustomSourceNew("");
      setIsSubmitting(false);
      await getAllRisks();
    } catch (error: any) {
      posthog.capture('employee_risk_create_failed', { error: error.response?.data?.message });
      setPageError(error.response.data.message);
      setIsSubmitting(false);
      return error;
    }
  };

  const getAllRisks = async () => {
      try {
        setIsLoadingRisks(true);
        const response = await instance.get(
          "/api/employee/riskRegister/UNDER_REVIEW"
        );

        const filteredRisks = response.data.data.filter(
          (risk: any) => !risk.isDeleted
        )

        setIsLoadingRisks(false);
        initFlowbite();
        setAllRisks(filteredRisks);
      } catch (error) {
        setIsLoadingRisks(false);
        console.error(error);
      }
    };
  useEffect(() => {
    posthog.capture('page_viewed', { page: 'employee_risk_registry' });

    const fetchDueDate = async () => {
      const theDueDate = await fetchEntryDueDate();
      // setDueDate(FormatDueDates(theDueDate));
      if (theDueDate && theDueDate < today) {
        // setIsEntryLocked(true);
        setIsEntryLocked(false);
      } else {
        setIsEntryLocked(false);
      }
    };

    fetchDueDate();

    getAllRisks();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const handlePageChange = (pageNumber: number) => {
    setCurrentPage(pageNumber);
  };
  const paginatedRisks = React.useMemo(() => {
    let risksToDisplay = allRisks;

    // Apply search filter
    if (searchTerm) {
      risksToDisplay = risksToDisplay.filter((risk: any) =>
        Object.values(risk).some((value) =>
          String(value).toLowerCase().includes(searchTerm.toLowerCase())
        )
      );
    }

    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    return risksToDisplay.slice(indexOfFirstItem, indexOfLastItem);
  }, [allRisks, currentPage, itemsPerPage, searchTerm]);

  const totalPages = Math.ceil(allRisks.length / itemsPerPage);

  const handleEditClick = (
    riskId: string,
    riskName: string,
    description: string,
    source: string,
    rootCause: string,
    objective: string,
    perspective: string
  ) => {
    setSelectedRiskId(riskId);
    setIsEditDrawerOpen(true);
    setHighlightedRiskId(riskId);
    const objectives = config.Factors.filter(
      (factor: any) => Object.keys(factor)[0] === perspective
    ).map((factor: any) => Object.values(factor)[0]);
    setFilteredObjectives(objectives);
    
    // Check if the source is a custom one (not in predefined sources)
    const isCustomSource = !sources.includes(source) && source !== "Select Source";
    if (isCustomSource) {
      setIsOtherSourceSelected(true);
      setCustomSource(source);
    } else {
      setIsOtherSourceSelected(false);
      setCustomSource("");
    }
    
    setCurrentRiskDetails({
      riskName: riskName,
      description: description,
      source: source,
      rootCause: rootCause,
      objective: objective,
      perspective: perspective,
    });
    setUpdatedRisk({
      riskName: riskName,
      description: description,
      source: source,
      rootCause: rootCause,
      perspective: perspective,
      objective: objective,
    });
  };

  const updateRisk = async (e: any) => {
    e.preventDefault();
    setIsSubmitting(true);
    try {
      await instance.put(
        `/api/employee/riskRegister/update/${selectedRiskId}`,
        updatedRisk
      );
      posthog.capture('employee_risk_updated', { riskId: selectedRiskId, perspective: updatedRisk.perspective, source: updatedRisk.source });
      if (closeEditRiskDrawerButtonRef.current) {
        closeEditRiskDrawerButtonRef.current.click();
      }
      setIsSubmitting(false);
      await getAllRisks();
    } catch (error) {
      setIsSubmitting(false);
      return error;
    }
  };

  const deleteRisk = async (e: any) => {
    e.preventDefault();
    setIsDeleting(true);

    try {
      await instance.delete(
        `/api/employee/riskRegister/delete/${selectedRiskId}`
      );
      posthog.capture('employee_risk_deleted', { riskId: selectedRiskId });
      if (closeEditRiskDrawerButtonRef.current) {
        closeEditRiskDrawerButtonRef.current.click();
      }
      setIsDeleting(false);
      await getAllRisks();
    } catch (error) {
      setIsDeleting(false);
      return error;
    }
  };

  useEffect(() => {
    const handleClickOutside = (event: any) => {
      if (
        editDrawerRef.current &&
        !editDrawerRef.current.contains(event.target)
      ) {
        setIsEditDrawerOpen(false);
        setHighlightedRiskId(null);
        setIsOtherSourceSelected(false);
        setCustomSource("");
      }
    };

    if (isEditDrawerOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      setHighlightedRiskId(null);
      document.removeEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isEditDrawerOpen]);

  const [openModal, setOpenModal] = useState(false);

  const columnHelper = createColumnHelper<Risk>();
  const columns = [
    columnHelper.accessor("riskNumber", {
      header: () => <span className="whitespace-nowrap">Risk Number</span>,
      cell: (info) => (
        <span className="whitespace-nowrap font-bold">{info.getValue()}</span>
      ),
      footer: (info) => info.column.id,
    }),
    columnHelper.accessor("createdAt", {
      header: () => <span className="whitespace-nowrap">Date Created</span>,
      cell: (info) => (
        <span className="whitespace-nowrap">
          {info.getValue() ? FormateDate(info.getValue()) : ""}
        </span>
      ),
      footer: (info) => info.column.id,
    }),
    columnHelper.accessor((row) => row.perspective, {
      id: "perspective",
      cell: (info) => <PerspectiveBadge value={info.getValue()} />,
      header: () => <span>Perspective</span>,
      footer: (info) => info.column.id,
    }),
    columnHelper.accessor("objective", {
      header: () => "Objective",
      cell: (info) => info.renderValue(),
      footer: (info) => info.column.id,
    }),
    columnHelper.accessor("riskName", {
      header: () => "Risk Name",
      cell: (info) => info.renderValue(),
      footer: (info) => info.column.id,
    }),
    columnHelper.accessor("source", {
      header: () => "Source",
      cell: (info) => info.renderValue(),
      footer: (info) => info.column.id,
    }),
    columnHelper.accessor("description", {
      header: () => "Description",
      cell: (info) => info.renderValue(),
      footer: (info) => info.column.id,
    }),
    columnHelper.accessor("rootCause", {
      header: () => "Root Cause",
      cell: (info) => info.renderValue(),
      footer: (info) => info.column.id,
    }),
    columnHelper.display({
      id: "actions",
      header: () => <span>Actions</span>,
      cell: ({ row }) => (
        <button
          type="button"
          className={`w-auto flex justify-center items-center text-white hover:text-black hover:bg-white hover:border-2 hover:border-caribbeanCurrent border border-caribbeanCurrent hover:bg-caribbeanCurrent focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-xs px-4 py-2 text-center inline-flex me-2 mb-2 dark:border-blue-500 dark:text-blue-500 dark:hover:text-white dark:hover:bg-caribbeanCurrent dark:focus:ring-blue-800 ${
            isEntryLocked
              ? "bg-gray-400 cursor-not-allowed text-white border-none hover:bg-gray-400"
              : "bg-caribbeanCurrent hover:bg-blue-800 focus:ring-blue-300 dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800"
          }`}
          disabled={isEntryLocked}
          data-drawer-target="drawer-edit-risk"
          data-drawer-show="drawer-edit-risk"
          data-drawer-placement="right"
          aria-controls="drawer-edit-risk"
          onClick={() =>
            handleEditClick(
              row.original.id || "",
              row.original.riskName,
              row.original.description,
              row.original.source,
              row.original.rootCause,
              row.original.objective,
              row.original.perspective
            )
          }
        >
          <svg
            className="w-4 h-4 text-white-800 dark:text-white me-2"
            aria-hidden="true"
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            fill="none"
            viewBox="0 0 24 24"
          >
            <path
              stroke="currentColor"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              d="m14.304 4.844 2.852 2.852M7 7H4a1 1 0 0 0-1 1v10a1 1 0 0 0 1 1h11a1 1 0 0 0 1-1v-4.5m2.409-9.91a2.017 2.017 0 0 1 0 2.853l-6.844 6.844L8 14l.713-3.565 6.844-6.844a2.015 2.015 0 0 1 2.852 0Z"
            />
          </svg>
          Edit
        </button>
      ),
    }),
  ];

  const table = useReactTable<Risk>({
    data: paginatedRisks,
    columns,
    getCoreRowModel: getCoreRowModel(),
  });

  if (tenantLoading || !config) {
    return (
      <div className="flex justify-center items-center h-screen">
        <Loader size="xl" />
      </div>
    );
  }

  return (
    <>
      {/* <!-- Breadcrumb --> */}
      <nav
        className="justify-between  py-3 text-gray-700  sm:flex bg-gray-50"
        aria-label="Breadcrumb"
      >
        <ol className="inline-flex items-center mb-3 space-x-1 md:space-x-2 rtl:space-x-reverse sm:mb-0">
          <li>
            <div className="flex items-center">
              <NavLink
                to=""
                className=" text-sm font-medium text-gray-700 hover:text-blue-600  dark:text-gray-400 dark:hover:text-white"
              >
                Risk Registration
              </NavLink>
            </div>
          </li>

          <li aria-current="page">
            <div className="flex items-center ">
              <svg
                className="rtl:rotate-180 w-3 h-3 mx-1 text-gray-400"
                aria-hidden="true"
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 6 10"
              >
                <path
                  stroke="currentColor"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="m1 9 4-4-4-4"
                />
              </svg>
              <span className="mx-1 text-sm font-medium text-gray-500 md:mx-2 dark:text-gray-400">
                Entry
              </span>
            </div>
          </li>
        </ol>
      </nav>
      <h1 className="text-xl mb-3 font-semibold text-gray-700">Risk Entry</h1>

      {/* <p className="text-caribbeanCurrent font-semibold">Due date: {dueDate}</p> */}
      <form className="flex max-w-sm my-4 justify-center items-center">
        <label
          htmlFor="countries"
          className="block mb-2 text-md font-medium text-gray-900 dark:text-white"
        >
          Department
        </label>
        <span className="ml-5 bg-gray-50 border border-caribbeanCurrent  text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500">
          {department}
        </span>
      </form>

      <div className="border-2 border-dashed rounded-lg border-gray-300 dark:border-gray-600 mb-4">
        <div className="p-5 text-lg font-semibold text-left rtl:text-right text-gray-900 bg-white dark:text-white dark:bg-gray-800 sticky top-0 z-20">
          <div className="w-full flex items-center justify-between">
            <p>My Risks</p>
            <div className="flex flex-row gap-4 items-center justify-center">
              <div className="">
                <TableSearchBar
                  searchTerm={searchTerm}
                  onSearchChange={setSearchTerm}
                  placeholder="Search risks..."
                />
              </div>
            </div>
            <button
              type="button"
              className={`text-white font-medium hover:text-black hover:bg-white hover:border-2 hover:border-caribbeanCurrent rounded-lg text-xs px-5 py-2.5 text-center inline-flex items-center me-2 focus:ring-4 focus:outline-none ${
                isEntryLocked
                  ? "bg-gray-400 cursor-not-allowed"
                  : "bg-caribbeanCurrent hover:bg-blue-800 focus:ring-blue-300 dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800"
              }`}
              data-drawer-target="drawer-new-risk"
              data-drawer-show="drawer-new-risk"
              disabled={isEntryLocked}
              data-drawer-placement="right"
              aria-controls="drawer-new-risk"
            >
              <svg
                className="w-4 h-4 text-white-800 dark:text-white me-2"
                aria-hidden="true"
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                fill="none"
                viewBox="0 0 24 24"
              >
                <path
                  stroke="currentColor"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M16 10.5h.01m-4.01 0h.01M8 10.5h.01M5 5h14a1 1 0 0 1 1 1v9a1 1 0 0 1-1 1h-6.6a1 1 0 0 0-.69.275l-2.866 2.723A.5.5 0 0 1 8 18.635V17a1 1 0 0 0-1-1H5a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1Z"
                />
              </svg>
              Add New Risk
            </button>
          </div>
        </div>
        <div className="rt-wrap relative sm:rounded-lg max-h-[calc(100vh-300px)] overflow-y-auto">
          <table className="w-full text-sm text-left rtl:text-right text-gray-500 dark:text-gray-400">
            <thead className="text-sm text-jet font-bold bg-gray-50 dark:bg-gray-700 dark:text-gray-400 sticky top-0 z-10">
              {table.getHeaderGroups().map((headerGroup) => (
                <tr key={headerGroup.id}>
                  {headerGroup.headers.map((header) => {
                    const isActionsColumn = header.column.id === "actions";
                    return (
                      <th
                        scope="col"
                        className={`px-6 py-3 ${
                          isActionsColumn
                            ? "sticky right-0 bg-gray-50 dark:bg-gray-700 z-10"
                            : ""
                        }`}
                        key={header.id}
                      >
                        {header.isPlaceholder
                          ? null
                          : flexRender(
                              header.column.columnDef.header,
                              header.getContext()
                            )}
                      </th>
                    );
                  })}
                </tr>
              ))}
            </thead>
            {isLoadingRisks ? (
              <tbody>
                <td colSpan={7} className="text-center">
                  <div className="flex justify-center items-center h-96">
                    <Loader size={"xl"} />
                  </div>
                </td>
              </tbody>
            ) : (
              <tbody className="text-jet font-medium text-xs">
                {table.getRowModel().rows.map((row) => (
                  <tr
                    key={row.id}
                    className={`bg-gray border-b border-t hover:bg-gray-100 dark:bg-gray-800 dark:border-gray-700 ${
                      highlightedRiskId === row.original.id ? "bg-gray-200" : ""
                    }`}
                  >
                    {row.getVisibleCells().map((cell) => {
                      const isActionsColumn = cell.column.id === "actions";
                      return (
                        <td
                          className={`px-6 py-4 align-top ${
                            isActionsColumn
                              ? "sticky right-0 bg-white dark:bg-gray-800"
                              : ""
                          }`}
                          key={cell.id}
                        >
                          {flexRender(
                            cell.column.columnDef.cell,
                            cell.getContext()
                          )}
                        </td>
                      );
                    })}
                  </tr>
                ))}
              </tbody>
            )}
          </table>

          {/* Pagination */}
          <div className="mt-4 pl-10 pr-10 pb-5 text-jet font-medium text-xs ">
            <nav aria-label="Page navigation">
              <ul className="flex justify-between">
                <li className="flex flex-row items-center">
                  <div>
                    <p>Show rows per page</p>
                  </div>
                  <div>
                    <select
                      className="ml-2 bg-gray-50 border border-caribbeanCurrent text-gray-900 text-xs rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                      onChange={(e) => setItemsPerPage(Number(e.target.value))}
                    >
                      <option>25</option>
                      <option>50</option>
                      <option>100</option>
                    </select>
                  </div>
                </li>
                <li className="flex flex-row gap-1 items-center text-gray-500">
                  <div>
                    <p>
                      {currentPage} of {totalPages === 0 ? 1 : totalPages}
                    </p>
                  </div>
                  <div>
                    <button
                      className="px-3 py-2 ml-0 leading-tight text-gray-500 bg-white border border-gray-300 rounded-l-lg rounded-r-lg hover:bg-gray-100 hover:text-gray-700 dark:bg-gray-800 dark:border-gray-700 dark:text-gray-400 dark:hover:bg-gray-700 dark:hover:text-white"
                      onClick={() => handlePageChange(currentPage - 1)}
                      disabled={currentPage === 1}
                    >
                      {"<"}
                    </button>
                  </div>
                  <div>
                    <button
                      className="px-3 py-2 leading-tight text-gray-500 bg-white border border-gray-300 rounded-r-lg rounded-l-lg hover:bg-gray-100 hover:text-gray-700 dark:bg-gray-800 dark:border-gray-700 dark:text-gray-400 dark:hover:bg-gray-700 dark:hover:text-white"
                      onClick={() => handlePageChange(currentPage + 1)}
                      disabled={currentPage === totalPages}
                    >
                      {">"}
                    </button>
                  </div>
                </li>
              </ul>
            </nav>
          </div>
        </div>
      </div>

      {/* drawers */}

      {/* new risk */}
      <div
        id="drawer-new-risk"
        className="fixed top-0 right-0 z-50 h-screen p-4 overflow-y-auto transition-transform translate-x-full bg-white w-full md:w-1/4  dark:bg-gray-800"
        tabIndex={-1}
        aria-labelledby="drawer-new-risk-label"
      >
        <h5
          id="drawer-label"
          className="inline-flex items-center mb-6 text-base font-semibold text-gray-500  dark:text-gray-400"
        >
          Add New Risk
        </h5>
        <button
          type="button"
          data-drawer-hide="drawer-new-risk"
          aria-controls="drawer-new-risk"
          className="text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm w-8 h-8 absolute top-2.5 end-2.5 inline-flex items-center justify-center dark:hover:bg-gray-600 dark:hover:text-white"
          ref={closeAddNewRiskDrawerButtonRef}
          onClick={() => {
            setIsOtherSourceSelectedNew(false);
            setCustomSourceNew("");
          }}
        >
          <svg
            className="w-3 h-3"
            // aria-hidden="true"
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 14 14"
          >
            <path
              stroke="currentColor"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              d="m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6"
            />
          </svg>
          <span className="sr-only">Close menu</span>
        </button>
        <form
          onSubmit={createNewRisk}
          className="border-2 border-dashed rounded-lg border-gray-300 dark:border-gray-600 h-full mb-4 p-4"
        >
          <div className="mb-6">
            <label
              htmlFor="perspective"
              className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
            >
              Perspective
            </label>
            <select
              id="perspective"
              required
              className=" bg-gray-50 border border-caribbeanCurrent  text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
              onChange={(e) => {
                const selectedPerspective = e.target.value;

                // Update the newRisk state
                setNewRisk((prevState) => ({
                  ...prevState,
                  perspective: selectedPerspective,
                }));
                // Filter objectives based on the selected perspective
                // Update the filtered objectives
                const objectives = config.Factors.filter((factor: any) =>
                  Object.keys(factor).includes(selectedPerspective)
                ).map((factor: any) => Object.values(factor)[0]);

                console.log("objectives: ", objectives);
                setFilteredObjectives(objectives);
              }}
            >
              <option>Select Perspective</option>
              {config.Perspective.map((perspective: any, index: any) => (
                <option key={index} value={perspective}>
                  {perspective}
                </option>
              ))}
            </select>
          </div>
          <div className="mb-6">
            <label
              htmlFor="objective"
              className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
            >
              Objective
            </label>
            <select
              id="objective"
              required
              className="bg-gray-50 border border-caribbeanCurrent text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
              onChange={(e) => {
                setNewRisk((prevState) => ({
                  ...prevState,
                  objective: e.target.value,
                }));
              }}
              value={newRisk.objective || ""}
            >
              <option>Select Objective</option>
              {filteredObjectives.map((objective, index) => (
                <option key={index} value={objective}>
                  {objective}
                </option>
              ))}
            </select>
          </div>
          <div className="mb-6">
            <label
              htmlFor="riskName"
              className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
            >
              Risk Name
            </label>
            <input
              type="text"
              id="riskName"
              onChange={(e) => {
                setNewRisk((prevState) => ({
                  ...prevState,
                  riskName: e.target.value,
                }));
              }}
              className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
              placeholder="Risk title goes here"
              required
            />
          </div>
          <div className="mb-6">
            <label
              htmlFor="riskSource"
              className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
            >
              Source
            </label>
            <select
              id="riskSource"
              required
              className=" bg-gray-50 border border-caribbeanCurrent  text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
              onChange={(e) => {
                const selectedValue = e.target.value;
                if (selectedValue === "Other") {
                  setIsOtherSourceSelectedNew(true);
                  setNewRisk((prevState) => ({
                    ...prevState,
                    source: customSourceNew, // Use custom source if already entered
                  }));
                } else {
                  setIsOtherSourceSelectedNew(false);
                  setCustomSourceNew("");
                  setNewRisk((prevState) => ({
                    ...prevState,
                    source: selectedValue,
                  }));
                }
              }}
            >
              <option>Select Source</option>
              {sources.map((source, index) => (
                <option key={index}>{source}</option>
              ))}
              <option>Other</option>
            </select>
          </div>
          {isOtherSourceSelectedNew && (
            <div className="mb-6">
              <label
                htmlFor="customSourceNew"
                className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
              >
                Specify Source
              </label>
              <input
                type="text"
                id="customSourceNew"
                className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                placeholder="Enter custom source"
                value={customSourceNew}
                onChange={(e) => {
                  const value = e.target.value;
                  setCustomSourceNew(value);
                  setNewRisk((prevState) => ({
                    ...prevState,
                    source: value,
                  }));
                }}
                required
              />
            </div>
          )}
          <div className="mb-6">
            <label
              htmlFor="riskDescription"
              className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
            >
              Risk Description
            </label>
            <textarea
              id="riskDescription"
              rows={4}
              required
              onChange={(e) => {
                setNewRisk((prevState) => ({
                  ...prevState,
                  description: e.target.value,
                }));
              }}
              className="block p-2.5 w-full text-sm text-gray-900 bg-gray-50 rounded-lg border border-gray-300 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
              placeholder="Description goes here..."
            ></textarea>
          </div>
          <div className="mb-6">
            <label
              htmlFor="riskCause"
              className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
            >
              Root Cause
            </label>
            <textarea
              id="riskCause"
              rows={4}
              onChange={(e) => {
                setNewRisk((prevState) => ({
                  ...prevState,
                  rootCause: e.target.value,
                }));
              }}
              required
              className="block p-2.5 w-full text-sm text-gray-900 bg-gray-50 rounded-lg border border-gray-300 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
              placeholder="Root cause goes here..."
            ></textarea>
          </div>
          <button
          disabled={isSubmitting}
            type="submit"
            className={`text-white bg-caribbeanCurrent hover:bg-blue-800 w-full focus:ring-4 focus:ring-caribbeanCurrent font-medium rounded-lg text-sm px-5 py-2.5 mb-2 dark:bg-caribbeanCurrent dark:hover:bg-caribbeanCurrent focus:outline-none dark:focus:ring-caribbeanCurrent block ${isSubmitting ? "opacity-50 cursor-not-allowed" : ""}`}
          >
            {isSubmitting ? <Loader size="sm" /> : "Submit Risk"}
          </button>
          {pageError && <p className="text-red">{pageError}!</p>}
        </form>
      </div>

      {/* edit risk */}
      {allRisks.length > 0 && (
        <div
          id="drawer-edit-risk"
          ref={editDrawerRef}
          className={`fixed top-0 right-0 z-50 h-screen p-4 overflow-y-auto transition-transform ${
            isEditDrawerOpen ? "translate-x-0" : "translate-x-full"
          } bg-white w-full md:w-1/4 dark:bg-gray-800`}
          tabIndex={-2}
          aria-labelledby="drawer-edit-risk-label"
        >
          <h5
            id="drawer-label"
            className="inline-flex items-center mb-6 text-base font-semibold text-gray-500  dark:text-gray-400"
          >
            Edit Risk
          </h5>
          <p className="text-sm my-4 text-gray-400">
            You are allowed to edit your risk before due date.
          </p>
          <button
            type="button"
            data-drawer-hide="drawer-new-risk"
            aria-controls="drawer-new-risk"
            className="text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm w-8 h-8 absolute top-2.5 end-2.5 inline-flex items-center justify-center dark:hover:bg-gray-600 dark:hover:text-white"
            ref={closeEditRiskDrawerButtonRef}
            onClick={() => {
              setIsEditDrawerOpen(false);
              setIsOtherSourceSelected(false);
              setCustomSource("");
            }}
          >
            <svg
              className="w-3 h-3"
              aria-hidden="true"
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 14 14"
            >
              <path
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6"
              />
            </svg>
            <span className="sr-only">Close menu</span>
          </button>
          <form
            onSubmit={updateRisk}
            className="border-2 border-dashed rounded-lg border-gray-300 dark:border-gray-600 h-full mb-4 p-4"
          >
            <div className="mb-6">
              <label
                htmlFor="perspective"
                className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
              >
                Perspective
              </label>
              <select
                id="perspective"
                className=" bg-gray-50 border border-caribbeanCurrent  text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                onChange={(e) => {
                  const selectedPerspective = e.target.value;

                  // Update the newRisk state
                  setUpdatedRisk((prevState) => ({
                    ...prevState,
                    perspective: selectedPerspective,
                  }));

                  // Filter objectives based on the selected perspective
                  const objectives = config.Factors.filter(
                    (factor: any) => Object.keys(factor)[0] === selectedPerspective
                  ).map((factor: any) => Object.values(factor)[0]);
                  setFilteredObjectives(objectives); // Update the filtered objectives
                }}
                value={updatedRisk.perspective || ""}
              >
                <option>Select Perspective</option>
                {config.Perspective.map((perspective: any, index: any) => (
                  <option key={index} value={perspective}>
                    {perspective}
                  </option>
                ))}
              </select>
            </div>
            <div className="mb-6">
              <label
                htmlFor="objective"
                className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
              >
                Objective
              </label>
              <select
                id="objective"
                required
                className="bg-gray-50 border border-caribbeanCurrent text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                onChange={(e) => {
                  setUpdatedRisk((prevState) => ({
                    ...prevState,
                    objective: e.target.value,
                  }));
                }}
                defaultValue={currentRiskDetails.objective}
              >
                <option>Select Objective</option>
                {filteredObjectives.map((objective, index) => (
                  <option key={index} value={objective}>
                    {objective}
                  </option>
                ))}
              </select>
            </div>
            <div className="mb-6">
              <label
                htmlFor="riskName"
                className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
              >
                Risk Name
              </label>
              <input
                type="text"
                id="riskName"
                className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                placeholder="Risk title goes here"
                required
                onChange={(e) => {
                  setUpdatedRisk((prevState) => ({
                    ...prevState,
                    riskName: e.target.value,
                  }));
                }}
                defaultValue={currentRiskDetails.riskName}
              />
            </div>
            <div className="mb-6">
              <label
                htmlFor="riskSource"
                className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
              >
                Risk Source
              </label>
              <select
                id="riskSource"
                className=" bg-gray-50 border border-caribbeanCurrent  text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                onChange={(e) => {
                  const selectedValue = e.target.value;
                  if (selectedValue === "Other") {
                    setIsOtherSourceSelected(true);
                    setUpdatedRisk((prevState) => ({
                      ...prevState,
                      source: customSource, // Use custom source if already entered
                    }));
                  } else {
                    setIsOtherSourceSelected(false);
                    setCustomSource("");
                    setUpdatedRisk((prevState) => ({
                      ...prevState,
                      source: selectedValue,
                    }));
                  }
                }}
                value={isOtherSourceSelected ? "Other" : (updatedRisk.source || "")}
              >
                <option>Select Source</option>
                {sources.map((source) => (
                  <option>{source}</option>
                ))}
                <option>Other</option>
              </select>
            </div>
            {isOtherSourceSelected && (
              <div className="mb-6">
                <label
                  htmlFor="customSource"
                  className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                >
                  Specify Source
                </label>
                <input
                  type="text"
                  id="customSource"
                  className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                  placeholder="Enter custom source"
                  value={customSource}
                  onChange={(e) => {
                    const value = e.target.value;
                    setCustomSource(value);
                    setUpdatedRisk((prevState) => ({
                      ...prevState,
                      source: value,
                    }));
                  }}
                  required
                />
              </div>
            )}
            <div className="mb-6">
              <label
                htmlFor="riskDescription"
                className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
              >
                Risk Description
              </label>
              <textarea
                id="riskDescription"
                rows={4}
                onChange={(e) => {
                  setUpdatedRisk((prevState) => ({
                    ...prevState,
                    description: e.target.value,
                  }));
                }}
                defaultValue={currentRiskDetails.description}
                className="block p-2.5 w-full text-sm text-gray-900 bg-gray-50 rounded-lg border border-gray-300 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                placeholder="Description goes here..."
              ></textarea>
            </div>
            <div className="mb-6">
              <label
                htmlFor="rootCause"
                className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
              >
                Root Causes
              </label>
              <textarea
                id="rootCause"
                rows={4}
                onChange={(e) => {
                  setUpdatedRisk((prevState) => ({
                    ...prevState,
                    rootCause: e.target.value,
                  }));
                }}
                defaultValue={currentRiskDetails.rootCause}
                className="block p-2.5 w-full text-sm text-gray-900 bg-gray-50 rounded-lg border border-gray-300 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                placeholder="Root cause goes here..."
              ></textarea>
            </div>
            <button
              disabled={isSubmitting}
              type="submit"
              className={`text-white bg-caribbeanCurrent hover:bg-blue-800 w-full focus:ring-4 focus:ring-caribbeanCurrent font-medium rounded-lg text-sm px-5 py-2.5 mb-2 dark:bg-caribbeanCurrent dark:hover:bg-caribbeanCurrent focus:outline-none dark:focus:ring-caribbeanCurrent block ${isSubmitting ? "opacity-50 cursor-not-allowed" : ""}`}
            >
              {isSubmitting ? <Loader size="sm" /> : "Save Risk"}
            </button>
            <button
              type="button"
              className="text-caribbeanCurrent w-full border border-caribbeanCurrent hover:bg-caribbeanCurrent focus:ring-4 focus:outline-none focus:ring-caribbeanCurrent font-medium rounded-lg text-sm px-5 py-2.5 text-center me-2 mb-2 dark:border-caribbeanCurrent dark:text-caribbeanCurrent hover:text-white dark:hover:text-white dark:hover:bg-caribbeanCurrent dark:focus:ring-caribbeanCurrent"
              onClick={() => setOpenModal(true)}
            >
              {isDeleting ? <Loader size="sm" /> : "Delete Risk"}
            </button>
            <Modal
              show={openModal}
              size="md"
              onClose={() => setOpenModal(false)}
              popup
            >
              <Modal.Header />
              <Modal.Body>
                <div className="text-center">
                  <HiOutlineExclamationCircle className="mx-auto mb-4 h-14 w-14 text-gray-400 dark:text-gray-200" />
                  <div className="gap-0 mb-4">
                    <h3 className="text-lg font-normal text-gray-500 dark:text-gray-400">
                      Are you sure you want to delete this risk?
                    </h3>
                    <h4 className="text-gray-500 dark:text-gray-400">
                      <span className="font-bold text-black">Note:</span> You
                      can't undo this action
                    </h4>
                  </div>
                  <div className="flex justify-center gap-4">
                    <Button
                      className="bg-caribbeanCurrent"
                      onClick={deleteRisk}
                    >
                      {isDeleting ? <Loader size="sm" /> : "Delete Risk"}
                    </Button>
                    <Button color="gray" onClick={() => setOpenModal(false)}>
                      Cancel
                    </Button>
                  </div>
                </div>
              </Modal.Body>
            </Modal>
          </form>
        </div>
      )}
    </>
  );
  //   }
}

export default connect()(RiskRegistry);
